import { routes } from "./routes";

export const SEARCH_HEADER_ITEMS = [
  {
    id: 0,
    label: "List",
    value: "list"
  },
  {
    id: 1,
    label: "Map",
    value: "map"
  }
];

export const LOADS_POST_HEADER_ITEMS = [
  {
    id: 0,
    label: "All Loads",
    value: "all_loads",
    link: routes.LOADS_POSTED_ALL
  },
  {
    id: 1,
    label: "HaulPay Loads",
    value: "haulPay_loads",
    link: routes.LOADS_POSTED_HAULPAY
  }
];
